import { type PatientRecord } from 'types/patient';
import { SICK_LEAVE_FIELD_KEY } from './constants';

interface HasMatchingPatientRecordParams {
  patientRecords: PatientRecord[];
  contractId: string;
  sickLeaveDate: unknown;
}

export const hasMatchingPatientRecord = ({
  patientRecords,
  contractId,
  sickLeaveDate,
}: HasMatchingPatientRecordParams): boolean =>
  typeof sickLeaveDate === 'string' &&
  patientRecords.some(
    patientRecord =>
      patientRecord.contract?.id === Number(contractId) &&
      patientRecord.values[SICK_LEAVE_FIELD_KEY] === sickLeaveDate
  );
